<template>
  <section>
    <div class="level">
      <div class="level-left">
        <h1>Women's {{ this.selectedSubmenu }}</h1>
      </div>
      <div v-if="this.isLoading" class="blink">
        <div class="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <!-- <div class="level-right">
        <button class="button" @click="addNewCollection">
          <span>Add a Collection</span>
        </button>
      </div> -->
    </div>
    <div v-if="this.analytics">
      <StyleAssortment :collection="selectedCollection" />
    </div>
    <div v-else>
      <div class="tile is-parent is-12 product-grid" v-if="this.products">
        <RetailerProduct
          v-for="product in this.products"
          :product="product"
          :key="product.id"
        />
      </div>
    </div>
  </section>
</template>

<script>
import RetailerProduct from "@/components/RetailerProduct";
// import ShapeWizard from '@/components/ShapeWizard'
import StyleAssortment from "@/components/StyleAssortment";

export default {
  name: "ProductGrid",
  components: {
    RetailerProduct,
    // ShapeWizard,
    StyleAssortment,
  },
  props: {
    products: Array,
    selectedCollection: Array,
    selectedProductType: String,
    selectedSubmenu: String,
    isLoading: Boolean,
  },
  data: function () {
    return {
      isShapeWizardModalActive: false,
      active: false,
      analytics: false,
      currentCollection: false,
    };
  },
  beforeUpdate() {
    if (this.currentCollection) {
      if (this.selectedCollection != this.currentCollection) {
        this.analytics = false;
      }
    }
  },
  methods: {
    addNewCollection: function () {
      this.$emit("add-collection");
    },
    toggleAnalytics() {
      if (!this.analytics) {
        this.currentCollection = this.selectedCollection;
      }
      this.analytics = !this.analytics;
    },
  },
};
</script>

<style lang="scss" scoped>
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: rgb(143, 143, 143);
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.level {
  padding-right: 1em;
  padding-top: -1rem;
}
h1 {
  font-size: 1.5em;
}
.product-grid {
  flex-wrap: wrap;
}
.button.is-success {
  background-color: #8ec740;
  &:hover {
    background-color: #fd9fa3;
  }
}
.blink {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  top: 0;
  display: grid;
  place-items: center;
  z-index: 100000;
}

@-webkit-keyframes blink {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
@keyframes blink {
  0%,
  50%,
  100% {
    opacity: 1;
  }
  25%,
  75% {
    opacity: 0;
  }
}
</style>
